import { render, staticRenderFns } from "./RecComplaint.vue?vue&type=template&id=eeeb6e64&scoped=true"
import script from "./RecComplaint.vue?vue&type=script&lang=js"
export * from "./RecComplaint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eeeb6e64",
  null
  
)

export default component.exports